<template>
    <div id="paintlist-paintshop-page">
        <div
            class="debug"
            v-if="isDebug"
        >
            {{ { paintlist, color, powder } }}
        </div>
        <div class="col-50">
            <!-- General info -->
            <div class="paintlistviewdiv">
                <div class="paintlistdivtitle">
                    {{ trans('pages.paintlistpaintshop.title') }}
                </div>
                <div class="paintlistdivelement">
                    <div class="paintlistelementtitle">
                        {{ trans('pages.paintlistpaintshop.korf') }}
                    </div>
                    <div
                        class="paintlistelementvalue vuevalue"
                        v-if="paintlist"
                    >
                        {{ paintlist.korf }}
                    </div>
                </div>
                <div class="paintlistdivelement">
                    <div class="paintlistelementtitle">
                        {{ trans('pages.paintlistpaintshop.volgnr') }}
                    </div>
                    <div
                        class="paintlistelementvalue vuevalue"
                        v-if="paintlist"
                    >
                        {{ paintlist.trackNr }}
                    </div>
                </div>
                <div class="paintlistdivelement">
                    <div class="paintlistelementtitle">
                        {{ trans('pages.paintlistpaintshop.productiebonnr') }}
                    </div>
                    <div class="paintlistelementvalue">
                        <ui5-input
                            type="Text"
                            :value="paintlistId"
                            @input="paintlistId = $event.target.value"
                            id="paintlist-id"
                            @blur="updatePaintlistIdForPaintshop"
                        />
                    </div>
                </div>
                <div class="paintlistdivelement">
                    <div class="paintlistelementtitle">
                        {{ trans('pages.paintlistpaintshop.vierkante_meter') }}
                    </div>
                    <div
                        class="paintlistelementvalue vuevalue"
                        v-if="paintlist"
                    >
                        {{ paintlist.area }}
                    </div>
                </div>
                <div class="paintlistdivelement">
                    <div class="paintlistelementtitle">
                        {{ trans('pages.paintlistpaintshop.aantal_stuks') }}
                    </div>
                    <div
                        class="paintlistelementvalue vuevalue"
                        v-if="paintlist"
                    >
                        {{ paintlist.count }}
                    </div>
                </div>
            </div>

            <!-- profiles -->
            <table
                cellspacing="0"
                cellpadding="0"
                class="product-table"
            >
                <thead>
                    <tr class="product-table-header-tr">
                        <th class="product-table-header-td">
                            {{ trans('pages.paintlistpaintshop.afbeelding') }}
                        </th>
                        <th
                            class="product-table-header-td"
                            align="left"
                        >
                            {{ trans('pages.paintlistpaintshop.omschrijving') }}
                        </th>
                        <th
                            class="product-table-header-td"
                            align="left"
                        >
                            {{ trans('pages.paintlistpaintshop.lengte') }}
                        </th>
                        <th
                            class="product-table-header-td"
                            align="left"
                        >
                            {{ trans('pages.paintlistpaintshop.aantal') }}
                        </th>
                    </tr>
                </thead>
                <tbody
                    id="paintlist-records"
                    v-if="paintlist && paintlist.records"
                >
                    <tr
                        v-for="record in paintlist.records"
                        :id="'profile-row-' + record.ID"
                        :key="'record.' + record.ID"
                        class="product-table-item-tr"
                    >
                        <td align="center">
                            <img
                                :src="
                                    Config.url +
                                    '/profile/fetchLakfoto/?profileId=' +
                                    record.profile
                                "
                                :alt="record.code"
                            />
                        </td>
                        <td align="left">
                            <div>
                                <div class="paintlistbold">
                                    {{ record.description }}
                                </div>
                                <div class="paintlistdefault">
                                    {{ record.code }}
                                </div>
                                <div
                                    v-if="record.showPaintlist == 0"
                                    class="paintlistred"
                                >
                                    {{
                                        trans(
                                            'pages.paintlistpaintshop.niet_lakken'
                                        )
                                    }}
                                </div>
                            </div>
                        </td>
                        <td align="left">
                            {{ record.length }}
                            {{ trans('pages.paintlistpaintshop.mm') }}
                        </td>
                        <td align="left">{{ record.count }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="col-50">
            <div class="col-50">
                <!-- color info -->
                <div
                    class="paintlistviewdiv"
                    id="color-container"
                    :style="{
                        background:
                            colorCodeManual.length == 0 || !color
                                ? 'inherit'
                                : colorCodeManual == color.powderId
                                ? 'chartreuse'
                                : 'lightcoral',
                    }"
                >
                    <div class="paintlistdivtitle">
                        {{ trans('pages.paintlistpaintshop.kleur') }}
                    </div>
                    <div class="paintlistdivelement">
                        <div class="paintlistelementtitle">
                            {{
                                trans(
                                    'pages.paintlistpaintshop.poedercode_manueel'
                                )
                            }}
                        </div>
                        <div
                            class="paintlistelementvalue"
                            @click="actionIfLoaded()"
                        >
                            <ui5-input
                                id="color-code-manual"
                                :disabled="!color"
                                :value="colorCodeManual"
                                @input="colorCodeManual = $event.target.value"
                                type="Text"
                            />
                        </div>
                    </div>
                    <div class="paintlistdivelement">
                        <div class="paintlistelementtitle">
                            {{ trans('pages.paintlistpaintshop.ralnummer') }}
                        </div>
                        <div
                            class="paintlistelementvalue vuevalue"
                            v-if="color"
                        >
                            {{ color.ral }}
                        </div>
                    </div>
                    <div class="paintlistdivelement">
                        <div class="paintlistelementtitle">
                            {{ trans('pages.paintlistpaintshop.poedernummer') }}
                        </div>
                        <div
                            class="paintlistelementvalue vuevalue"
                            v-if="color"
                        >
                            {{ color.powderCode }}
                        </div>
                    </div>
                    <div class="paintlistdivelement">
                        <div class="paintlistelementtitle">
                            {{ trans('pages.paintlistpaintshop.bin_locatie') }}
                        </div>
                        <div
                            class="paintlistelementvalue vuevalue"
                            v-if="color"
                        >
                            {{ color.powderBinLocation }}
                        </div>
                    </div>
                    <div class="paintlistdivelement">
                        <div class="paintlistelementtitle">
                            {{ trans('pages.paintlistpaintshop.poedercode') }}
                        </div>
                        <div
                            class="paintlistelementvalue vuevalue"
                            v-if="color"
                        >
                            {{ color.powderId }}
                        </div>
                    </div>
                    <div class="paintlistdivelement">
                        <div class="paintlistelementtitle">
                            {{ trans('pages.paintlistpaintshop.producent') }}
                        </div>
                        <div
                            class="paintlistelementvalue vuevalue"
                            v-if="color"
                        >
                            {{ color.manufacturer }}
                        </div>
                    </div>
                    <div class="paintlistdivelement">
                        <div class="paintlistelementtitle">
                            {{ trans('pages.paintlistpaintshop.balken') }}
                        </div>
                        <div
                            class="paintlistelementvalue"
                            @click="actionIfLoaded()"
                        >
                            <text-input
                                type="number"
                                :value="paintlist ? paintlist.beams : ''"
                                @input="paintlist.beams = $event"
                                :disabled="!paintlist || !color"
                                @change="beamsOnChange"
                            />
                        </div>
                    </div>
                    <div class="paintlistdivelement">
                        <div class="paintlistelementtitle">
                            {{
                                trans('pages.paintlistpaintshop.balken_totaal')
                            }}
                        </div>
                        <div
                            class="paintlistelementvalue vuevalue"
                            v-if="color"
                        >
                            {{ color.beams }}
                        </div>
                    </div>
                    <div class="paintlistdivelement">
                        <div class="paintlistelementtitle">
                            {{ trans('pages.paintlistpaintshop.sortering') }}
                        </div>
                        <div
                            class="paintlistelementvalue"
                            @click="actionIfLoaded()"
                        >
                            <text-input
                                type="number"
                                :value="color ? color.sort : ''"
                                @input="color.sort = $event"
                                @blur="updateColorSort"
                                :class="color ? color.sortClass : {}"
                                min="1"
                                max="10"
                                :disabled="!color"
                                id="color-sort"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-50">
                <!-- Powder usage -->
                <div class="paintlistviewdiv">
                    <div class="paintlistdivtitle">
                        {{ trans('pages.paintlistpaintshop.poeder_verbruik') }}
                    </div>
                    <div class="paintlistdivelement">
                        <div class="paintlistelementtitle">
                            {{
                                trans('pages.paintlistpaintshop.huidige_stock')
                            }}
                        </div>
                        <div
                            class="paintlistelementvalue vuevalue"
                            v-if="powder"
                        >
                            {{ powder.current }}
                        </div>
                    </div>
                    <div class="paintlistdivelement">
                        <div class="paintlistelementtitle">
                            {{
                                trans(
                                    'pages.paintlistpaintshop.gewicht_verpakking'
                                )
                            }}
                        </div>
                        <div
                            class="paintlistelementvalue"
                            @click="actionIfLoaded()"
                        >
                            <text-input
                                type="number"
                                :value="powder ? powder.package : ''"
                                @input="powder.package = $event"
                                :disabled="!powder || !color"
                            />
                        </div>
                    </div>
                    <div class="paintlistdivelement">
                        <div class="paintlistelementtitle">
                            {{ trans('pages.paintlistpaintshop.gewogen') }}
                        </div>
                        <div
                            class="paintlistelementvalue"
                            @click="actionIfLoaded()"
                        >
                            <text-input
                                type="number"
                                :value="powder ? powder.weighted : ''"
                                @input="powder.weighted = $event"
                                :disabled="
                                    !powder ||
                                    !color ||
                                    !paintlist ||
                                    paintlist.appliedPowderUsage
                                "
                            />
                            <ui5-button
                                id="powder-process"
                                @click="onPowderProcess"
                                v-show="
                                    color &&
                                    paintlist &&
                                    !paintlist.appliedPowderUsage
                                "
                            >
                                {{
                                    trans('pages.paintlistpaintshop.verwerken')
                                }}
                            </ui5-button>
                            <ui5-button
                                id="powder-revert"
                                @click="applyPowderUsage(false)"
                                v-show="
                                    color &&
                                    paintlist &&
                                    paintlist.appliedPowderUsage
                                "
                            >
                                {{
                                    trans(
                                        'pages.paintlistpaintshop.ongedaan_maken'
                                    )
                                }}
                            </ui5-button>
                        </div>
                    </div>
                    <div class="paintlistdivelement">
                        <div class="paintlistelementtitle">
                            {{
                                trans(
                                    'pages.paintlistpaintshop.vierkante_meter'
                                )
                            }}
                        </div>
                        <div
                            class="paintlistelementvalue vuevalue"
                            v-if="paintlist"
                        >
                            {{ paintlist.area }}
                        </div>
                    </div>
                    <div class="paintlistdivelement">
                        <div class="paintlistelementtitle">
                            {{ trans('pages.paintlistpaintshop.min_stock') }}
                        </div>
                        <div
                            class="paintlistelementvalue vuevalue"
                            v-if="powder"
                        >
                            {{ powder.minStock }}
                        </div>
                    </div>
                    <div
                        class="paintlistdivelement"
                        id="paintlist-powder-usage"
                    >
                        <div class="paintlistelementtitle">
                            {{ trans('pages.paintlistpaintshop.verbruik') }}
                        </div>
                        <div
                            class="paintlistelementvalue"
                            id="powder-usage"
                            v-if="powder"
                        >
                            {{ powder.usage }}
                        </div>
                    </div>
                    <div class="paintlistdivelement">
                        <div class="paintlistelementtitle">
                            {{
                                trans(
                                    'pages.paintlistpaintshop.verbruik_per_vierkante_meter'
                                )
                            }}
                        </div>
                        <div
                            class="paintlistelementvalue vuevalue"
                            v-if="powder"
                        >
                            {{ powder.usageBySize }}
                        </div>
                    </div>
                    <div
                        v-show="showPowderDifferenceWarning"
                        class="powder-warning paintlistdivelement vuevalue"
                    >
                        {{
                            trans(
                                'pages.paintlistpaintshop.berekend_verbruik_waarschuwing',
                                { usage: powder ? powder.calculatedUsage : '' }
                            )
                        }}
                    </div>
                    <div
                        v-show="showPowderUsageWarning"
                        class="powder-warning paintlistdivelement"
                    >
                        {{
                            trans(
                                'pages.paintlistpaintshop.abnormaal_verbruik_waarschuwing'
                            )
                        }}
                    </div>
                </div>
            </div>

            <!-- extra information -->
            <div class="paintlistviewdiv">
                <div class="paintlistdivtitle">
                    {{
                        trans('pages.paintlistpaintshop.bijkomende_informatie')
                    }}
                </div>
                <div class="paintlistdivelement"></div>
            </div>

            <div class="col-50">
                <div class="paintlistviewdiv">
                    <div class="paintlistdivtitle">
                        {{
                            trans('pages.paintlistpaintshop.kwaliteitscontrole')
                        }}
                    </div>
                    <div class="paintlistdivelement">
                        <div
                            class="productaction"
                            id="paintlist-accepted"
                            @click="actionIfLoaded(onAccepted)"
                        >
                            <p class="productactiontitle">
                                {{
                                    trans(
                                        'pages.paintlistpaintshop.goedgekeurd'
                                    )
                                }}
                            </p>
                            <div class="productactionimgdiv">
                                <i class="fa fa-check fa-3x" />
                            </div>
                        </div>

                        <div
                            class="productaction"
                            id="paintlist-rejected"
                            @click="actionIfLoaded(onRejected)"
                        >
                            <p class="productactiontitle">
                                {{
                                    trans('pages.paintlistpaintshop.afgekeurd')
                                }}
                            </p>
                            <div class="productactionimgdiv">
                                <i class="fa fa-close fa-3x" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="print-container col-50">
                <div
                    class="paintlistviewdiv"
                    id="paintlist-package"
                >
                    <div
                        class="paintlistdivtitle"
                        v-if="flowPaintshop"
                    >
                        {{ trans('pages.paintlistpaintshop.verpakken') }}
                    </div>
                    <div
                        class="paintlistdivtitle"
                        v-else="flowPaintshop"
                    >
                        {{ trans('pages.paintlistpaintshop.box') }}
                    </div>
                    <div
                        class="productaction"
                        @click="actionIfLoaded(onPrintLabels)"
                    >
                        <p class="productactiontitle">
                            {{
                                trans(
                                    'pages.paintlistpaintshop.etiketten_afdrukken'
                                )
                            }}
                        </p>
                        <div class="productactionimgdiv">
                            <i class="fa fa-print fa-3x" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import optimizedPaintListApi from '../api/optimizedPaintList';
import colorApi from '../api/color';
import profileApi from '../api/profile';
import exportApi from '../api/export';
import IsDebugMixin from '../mixins/is-debug';
import { precisionRound } from '../helpers/MathHelper';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';
import TextInput from '../components/TextInput.vue';

const FLOW_PAINTSHOP = 9;

export default {
    mixins: [IsDebugMixin, localization],
    components: { TextInput },
    data() {
        return {
            paintlistId: '',
            colorCodeManual: '',
            color: null,
            paintlist: null,
            powder: null,
            Config,
            showPowderDifferenceWarning: false,
            showPowderUsageWarning: false,
        };
    },
    mounted() {
        const paintlistId = this.$route.query.paintlistId;
        this.initPaintlistPaintshop(paintlistId);
    },
    computed: {
        selectedPrinterPostParameter() {
            return this.$store.getters[
                'printers/getSelectedPrinterPostParameter'
            ]();
        },
        flowPaintshop() {
            if (!this.paintlist || !this.paintlist.products) {
                return null;
            }
            return this.paintlist.products.some(
                (x) => product.flow != FLOW_PAINTSHOP
            );
        },
    },
    methods: {
        actionIfLoaded(action) {
            if (this.paintlist && this.color && this.powder) {
                if (action) {
                    action();
                }
            } else {
                showErrorMessage(
                    this.trans('pages.paintlistpaintshop.input_error_message')
                );
            }
        },
        initPaintlistPaintshop(paintlistId) {
            this.resetPaintlistPaintshop();

            if (paintlistId) {
                this.paintlistId = paintlistId;
                this.updatePaintlistIdForPaintshop();
            }

            this.$bus.$on('barcode-scan', (data) => {
                if (data.startsWith('L')) {
                    this.paintlistId = data;
                    this.updatePaintlistIdForPaintshop();
                }

                if (data.startsWith('ER')) {
                    this.colorCodeManual = data;
                }
            });
        },
        onAccepted() {
            optimizedPaintListApi
                .updateProductsStatus(
                    this.paintlistId,
                    'IP',
                    this.$store.getters['currentUser/getUserId']
                )
                .then(() => {
                    showInfoMessage(
                        this.trans('pages.paintlistpaintshop.products_approved')
                    );
                });
        },
        onRejected() {
            optimizedPaintListApi
                .updateProductsStatus(
                    this.paintlistId,
                    'FM',
                    this.$store.getters['currentUser/getUserId']
                )
                .then(() => {
                    showInfoMessage(
                        this.trans('pages.paintlistpaintshop.products_rejected')
                    );
                });
        },
        updatePaintlistIdForPaintshop() {
            this.resetPaintlistPaintshop();

            if (this.paintlistId.length > 0) {
                this.showPaintlistPaintshop();
            }
        },
        onPrintLabels() {
            KeyHelper.handlePrintOrExport(
                () => exportApi
                    .printPaintListProductionLabels(this.paintlistId, this.selectedPrinterPostParameter)
                    .then(() => {
                        showInfoMessage(
                            this.trans('pages.paintlistpaintshop.production_labels_printed')
                        );
                    })
                    .catch(() => {
                        showErrorMessage(this.trans('pages.paintlistpaintshop.print_error'));
                    }),
                Config.url + '/export/exportPaintListProductionLabels/?paintlistId=' + this.paintlistId
            );
        },
        onPowderProcess() {
            var powderUsage = parseFloat(this.powder.current.toString());
            powderUsage += parseFloat(this.powder.package.toString());
            powderUsage -= parseFloat(this.powder.weighted.toString());

            let askConfirmation = false;

            // Ask for confirmation when difference between calculated powder usage is too high
            if (
                Math.abs(powderUsage - this.paintlist.calculatedPowderUsage) >=
                    7000 &&
                !this.showPowderDifferenceWarning
            ) {
                this.powder.calculatedUsage = precisionRound(powderUsage, 2);
                this.showPowderDifferenceWarning = true;
                askConfirmation = true;
            }

            // Ask for confirmation when powder usage is high
            if (powderUsage > 5000 && !this.showPowderUsageWarning) {
                this.showPowderUsageWarning = true;
                askConfirmation = true;
            }

            if (!askConfirmation) {
                this.showPowderDifferenceWarning = false;
                this.showPowderUsageWarning = false;
                this.applyPowderUsage(true);
            }
        },
        showPaintlistPaintshop() {
            var paintlist;

            optimizedPaintListApi
                .fetch(this.paintlistId)
                .then((response) => {
                    const data = response.data;
                    paintlist = data.data;

                    this.paintlistId = paintlist.ID;

                    this.paintlist = {
                        ID: paintlist.ID,
                        korf: paintlist.korf,
                        trackNr: paintlist.trackNr,
                        area: precisionRound(paintlist.area, 2),
                        count: paintlist.count,
                        records: paintlist.records,
                        color: paintlist.color,
                        calculatedPowderUsage: paintlist.calculatedPowderUsage,
                        appliedPowderUsage: paintlist.appliedPowderUsage,
                        beams: paintlist.beams,
                    };

                    this.showPowderDifferenceWarning = false;
                    this.showPowderUsageWarning = false;

                    // Retrieve the color
                    colorApi
                        .fetchPaintlist(data.data.color)
                        .then((response) => {
                            var color = response.data.data;

                            this.color = {
                                id: parseInt(color.id),
                                powderId: color.powderCode,
                                ral: color.ralnr + ' ' + color.raltype,
                                powderCode: color.poedernr,
                                powderBinLocation: color.powderBinLocation,
                                manufacturer: color.producent,
                                beams: color.beams,
                                sort: parseInt(color.sort),
                                sortClass: {},
                            };

                            // Retrieve the profile
                            profileApi
                                .fetch(color.powderId)
                                .then((response) => {
                                    var powderData = response.data.data;

                                    const powder = {
                                        current: precisionRound(
                                            powderData.currentstockcount * 1000,
                                            2
                                        ), // Convert kg to gr
                                        minStock: precisionRound(
                                            powderData.minStock,
                                            2
                                        ),
                                        calculatedUsage: '',
                                        package: precisionRound(
                                            color.powderWeightBox,
                                            2
                                        ),
                                    };

                                    var powderWeighted = 0;
                                    var powderUsage = 0;
                                    var powderUsageBySize = 0;
                                    if (paintlist.appliedPowderUsage) {
                                        powderWeighted =
                                            powderData.currentstockcount * 1000;
                                        powderWeighted += parseFloat(
                                            powder.package.toString()
                                        );

                                        powderUsage = paintlist.powderUsage;
                                        powderUsageBySize =
                                            paintlist.powderUsage /
                                            paintlist.area;
                                        powderUsageBySize = isFinite(
                                            powderUsageBySize
                                        )
                                            ? powderUsageBySize
                                            : 0;
                                    }

                                    powder.weighted = precisionRound(
                                        powderWeighted,
                                        2
                                    );
                                    powder.usage = precisionRound(
                                        powderUsage,
                                        2
                                    );
                                    powder.usageBySize = precisionRound(
                                        powderUsageBySize,
                                        2
                                    );

                                    this.powder = powder;
                                });
                        });

                    // Show the correct packaging
                })
                .catch((ex) => {
                    showErrorMessage(
                        this.trans(
                            'pages.paintlistpaintshop.invalid_production_number'
                        )
                    );
                });
        },
        beamsOnChange() {
            optimizedPaintListApi
                .setBeams(this.paintlistId, this.paintlist.beams)
                .then(() => {
                    colorApi
                        .fetchPaintlist(this.paintlist.color)
                        .then((response) => {
                            const color = response.data.data;
                            this.color.beams = color.beams;
                        });
                });
        },
        resetPaintlistPaintshop() {
            this.colorCodeManual = '';
            this.color = null;
            this.paintlist = null;
            this.powder = null;

            //Hide some conditional fields
            this.showPowderDifferenceWarning = false;
            this.showPowderUsageWarning = false;
        },
        updateColorSort() {
            const sort = parseInt(this.color.sort);

            this.color.sortClass = {};

            if (sort != '' && !isNaN(sort) && sort >= 0 && sort <= 10) {
                return colorApi
                    .updateSort(this.color.id, sort)
                    .then(() => {
                        this.color.sortClass = { inputsuccess: true };
                    })
                    .catch(() => {
                        this.color.sortClass = { inputerror: true };
                    });
            } else {
                // Show error sign
                this.color.sort = 0;
                this.color.sortClass = { inputerror: true };
            }
        },
        applyPowderUsage(apply) {
            let calculatedPowderUsage = parseFloat(
                this.powder.current.toString()
            );
            calculatedPowderUsage += parseFloat(this.powder.package.toString());
            calculatedPowderUsage -= parseFloat(
                this.powder.weighted.toString()
            );

            const area = parseFloat(this.paintlist.area.toString());

            optimizedPaintListApi
                .updatePowderUsage(
                    this.paintlistId,
                    calculatedPowderUsage,
                    apply,
                    this.$store.getters['currentUser/getUserId']
                )
                .then((response) => {
                    const usageData = response.data.data;
                    this.powder.current = precisionRound(
                        usageData.powderStock * 1000,
                        2
                    );
                    this.powder.usage = precisionRound(
                        usageData.powderUsage,
                        2
                    );
                    const usage = usageData.powderUsage / area;
                    this.powder.usageBySize = precisionRound(
                        isFinite(usage) ? usage : 0,
                        2
                    );
                    this.paintlist.appliedPowderUsage =
                        usageData.appliedPowderUsage;
                });
        },
    },
};
</script>
